<template>
  <div class="flex_vertial">
    <div style="flex:1;"></div>
    <img class="robot" src="../../assets/irobot2.png">
    <div class="head_title">呼叫本机后是否有助理接听？</div>
    <div class="head_title_gray">温馨提示：助理默认声音为女声</div>
    <div style="flex:4;"></div>
    <div class="open_button" @click="finishBind">是，完成设置</div>
    <div class="open_button_white" @click="busyproblem">否，通话反馈正忙</div>
  </div>
</template>

<script>

import lubanApi from '@/lubanApi'
import util from '@/utils/util'
import app from '@/AppData'

export default {
  name: 'bindGuidePage',
  data () {
    return {}
  },
  methods: {
    finishBind () {
      lubanApi.reportseer('AICall_Open_Function_Confirm_Page_Sure_Button_Click')
      if (app.isVip()) {
        util.Toast('恭喜你已开通成功', 5000)
        this.$router.replace({
          path: '/'
        })
      } else {
        this.$router.replace({
          path: '/bindsuccess'
        })
      }
    },
    busyproblem () {
      util.openHelpWeb()
      lubanApi.reportseer('AICall_Open_Function_Confirm_Page_Negative_Button_Click')
    }
  },
  mounted () {
    lubanApi.reportseer('AICall_Open_Function_Confirm_Page_Shown')
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
.robot {
  width: 11rem;
  height: 11rem;
}
</style>



// WEBPACK FOOTER //
// src/components/bind/BindDailTryVerify.vue